module.exports = __webpack_public_path__ + "static/img/far1_active.c12c9017.png";